//React
import { NavLink, useHistory, useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
//Styles&Images
import { HeaderContainer } from "../../styled-components/Nav.styles";
import logo from "../../assets/logo-Origo-icon-fc.svg";
import logoHorizontal from "../../assets/logo-Origo-h-cf.svg";
//Hooks
import useDropdown from "../hooks/useDropdown";
//Actions
import { logingOut } from "../../actions/auth";
//Componentes
import BurgerMenu from "../navigation/BurgerMenu";
import MenuDropdown from "../generalComponents/MenuDropdown";

const Header = () => {
  //States Locals
  const { openmenu, ref, onClickDropDown } = useDropdown();
  //States from Redux
  const state = useSelector((state) => state.auth.user);
  //Hooks
  const { url } = useRouteMatch();
  const dispatch = useDispatch();
  const history = useHistory();
  //Handlers
  const onClickLogOut = () => {
    dispatch(logingOut());
    // history.push('/')
    history.replace("/");
  };

  return (
    <HeaderContainer>
      <div className="heading__logo">
        <NavLink to={`${url}`}>
          <picture>
            <source media="(min-width:1024px)" srcSet={logoHorizontal} />
            <img src={logo} alt="" />
          </picture>
        </NavLink>
      </div>

      <div ref={ref} style={{ position: "relative" }}>
        <BurgerMenu onclick={onClickDropDown} />
        {openmenu && (
          <MenuDropdown>
            <div className="heading__dropdown">
              <span className="paragraph-gray-reg-14">Hi,</span>
              <span className="paragraph-gray-bold-14">
                {state && state.name}
              </span>
            </div>

            <button className="btn btn-logout" onClick={onClickLogOut}>
              logout
            </button>
          </MenuDropdown>
        )}
      </div>
    </HeaderContainer>
  );
};

export default Header;
